export enum WeatherStatus {
    Approved = "approved",
    Warning = "warning",
    Danger = "danger",
    None = "none",
}
